import type { DeliveryType } from 'shared/src/api/goodsService/getGoodsOptions';
import { TodayDeliveryOptionBadge } from './TodayDeliveryOptionBadge';
import { StandardOptionBadge } from './StandardOptionBadge';

export const OptionBadge = ({
  deliveryType,
  isSoldOut,
  orderDeadline,
}: {
  deliveryType: DeliveryType;
  isSoldOut: boolean;
  orderDeadline: string | null;
}) => {
  const isTodayDelivery = deliveryType === 'today' || deliveryType === 'shak';

  if (isTodayDelivery) {
    return (
      <TodayDeliveryOptionBadge
        isSoldOut={isSoldOut}
        orderDeadline={orderDeadline}
      />
    );
  }

  return <StandardOptionBadge />;
};
